import React from 'react';
import { Header } from '../common_v2/components/Header';
import { Footer } from '../common_v2/components/Footer';
import NoticesBase from './components/NoticesBase/NoticesBase';
import './scss/_notices.scss';

export default function NoticesPageV2() {
    return (
        <>
            <div className='app-container'>
                <Header />
                <main>
                    <div className='content'>
                        <div
                            className='contentSection'
                            style={{ width: '100%' }}
                        >
                            <div className='columns small-12 large-12'>
                                <h1 className='notices-title'>Notices</h1>
                            </div>
                            <NoticesBase />
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
}
